import { createSlice } from "@reduxjs/toolkit";
import VwHbsOrderIlacDTO from "src/models/Order/VwHbsOrderIlacDTO";
import VwHbsorderhastaDTO from "src/models/StokEczane/OrderTalep/VwHbsorderhastaDTO";
import VwStkHbsOrderDTO from "src/models/StokEczane/OrderTalep/VwStkHbsOrderDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { OrderTalepApi } from "src/services/StokEczane/OrderTalepApi";

class OrderTalepAramaKriterleri {
    basTarih: string;
    bitTarih: string;
    depoTanimId: number;
    refetch: boolean;
    onayli: string = 'H';
    acil: string = 'H';
    hastamuracaatId?: number;
    tarihTip?: string; // 0 : islemTarihi, 1 : planTarihi
    iptalleriGetir?: string = 'H';
}
export class OrderDetayDetails {
    id?: number
    orderId?: number;
    depoId?: number;
    muracaatId?: number;
    onayli?: string;
}

export class OrderServis {
    servisId: number;
    servisAd: string = '';
}

export class OrderTalepKabulEtIstek {
    hastaList: Array<VwHbsorderhastaDTO>
    ilacList: Array<VwHbsOrderIlacDTO>
    doktorAciklama: string = '';
    doktorId: number = null;
    redNedenAciklama?: string = "";
    redNedenId?: number = null;
}

interface IOrderTalepState {
    aramaKriterleri: OrderTalepAramaKriterleri,
    // selectedOrderDetay: OrderDetayDetails,
    selectedOrderDetay: VwHbsOrderIlacDTO,
    selectedOrderServis: OrderServis,
    orderList: Array<VwStkHbsOrderDTO>,
    orderDetayList: Array<VwHbsOrderIlacDTO>
    orderHastaListActiveRow: VwHbsorderhastaDTO,
    seciliHastaListesi: Array<VwHbsorderhastaDTO>,
    orderHastaListesiMain: Array<VwHbsorderhastaDTO>,
    seciliOrderIlacListesi: Array<VwHbsOrderIlacDTO>,
    servisList: Array<OrderServis>,

    aktifSeciliHastaListesi: Array<VwHbsorderhastaDTO>,
    aktifSeciliIlacListesi: Array<VwHbsOrderIlacDTO>,
    kaldirilanIlacIdListesi: Array<number>,

    // OrderOnayliIslemleriListesi
    onayliHastaListesi: Array<VwHbsorderhastaDTO>,
    onayliIlacListesi: Array<VwHbsOrderIlacDTO>,
    onayliHastaActiveRow: VwHbsorderhastaDTO,
    onayliIlacActiveRow: VwHbsOrderIlacDTO,
    onayliAramaKriterleri : OrderTalepAramaKriterleri
    // İptal edilen order kayıtları
    iptalOrderAramaKriterleri: OrderTalepAramaKriterleri,
    iptalOrderListesi : Array<VwHbsOrderIlacDTO>,
    iptalOrderSeciliList : Array<VwHbsOrderIlacDTO>,
}

const OrderTalepSlice = createSlice<IOrderTalepState, MapReducerPayloads<
    IOrderTalepState,
    {
        setAramaKriterleri: OrderTalepAramaKriterleri,
        // setSelectedOrderDetay: OrderDetayDetails,
        setSelectedOrderDetay: VwHbsOrderIlacDTO,
        setOrderList: Array<VwStkHbsOrderDTO>,
        setOrderDetayList: Array<VwHbsOrderIlacDTO>,
        setOrderHastaListActiveRow: VwHbsorderhastaDTO,
        setSeciliHastaListesi: Array<VwHbsorderhastaDTO>,
        setOrderHastaListMain: Array<VwHbsorderhastaDTO>,
        setSelectedOrderServis: OrderServis,
        setSeciliOrderIlacListesi: Array<VwHbsOrderIlacDTO>,
        setServisList: Array<OrderServis>,

        setAktifSeciliHastaListesi: Array<VwHbsorderhastaDTO>,
        setAktifSeciliIlacListesi: Array<VwHbsOrderIlacDTO>,
        setKaldirilanIlacIdListesi: Array<number>,

        // OrderOnayliIslemleriListesi
        setOnayliHastaListesi: Array<VwHbsorderhastaDTO>,
        setOnayliIlacListesi: Array<VwHbsOrderIlacDTO>,
        setOnayliHastaActiveRow: VwHbsorderhastaDTO,
        setOnayliIlacActiveRow: VwHbsOrderIlacDTO,
        setOnayliAramaKriterleri : OrderTalepAramaKriterleri,
        // order iptaller listesi
        setIptalOrderAramaKriterleri: OrderTalepAramaKriterleri,
        setIptalOrderListesi: Array<VwHbsOrderIlacDTO>,
        setIptalOrderSeciliList : Array<VwHbsOrderIlacDTO>,
    }
>>({
    name: 'OrderTalep',
    initialState: {
        aramaKriterleri: {
            ...new OrderTalepAramaKriterleri(),
            refetch: false
        },
        // selectedOrderDetay: new OrderDetayDetails(),
        selectedOrderDetay: new VwHbsOrderIlacDTO(),
        orderList: [],
        orderDetayList: [],
        orderHastaListActiveRow: new VwHbsorderhastaDTO(),
        orderHastaListesiMain: [],
        selectedOrderServis: new OrderServis(),
        seciliHastaListesi: [],
        seciliOrderIlacListesi: [],
        servisList: [],

        aktifSeciliHastaListesi: [],
        aktifSeciliIlacListesi: [],
        kaldirilanIlacIdListesi: [],

        // OrderOnayliIslemleriListesi
        onayliHastaListesi: [],
        onayliIlacListesi: [],
        onayliHastaActiveRow: new VwHbsorderhastaDTO(),
        onayliIlacActiveRow: new VwHbsOrderIlacDTO(),
        
        onayliAramaKriterleri : {
            ...new OrderTalepAramaKriterleri(),
            refetch: false
        },
        iptalOrderAramaKriterleri: new OrderTalepAramaKriterleri(),
        iptalOrderListesi : [],
        iptalOrderSeciliList: [],
    },
    reducers: {
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload
        },
        setSelectedOrderDetay: (state, action) => {
            state.selectedOrderDetay = action.payload
        },
        setOrderList: (state, action) => {
            state.orderList = action.payload
        },
        setOrderDetayList: (state, action) => {
            state.orderDetayList = action.payload
        },
        setOrderHastaListActiveRow: (state, action) => {
            state.orderHastaListActiveRow = action.payload
        },
        setOrderHastaListMain: (state, action) => {
            state.orderHastaListesiMain = action.payload
        },
        setSelectedOrderServis: (state, action) => {
            state.selectedOrderServis = action.payload
        },
        setSeciliHastaListesi: (state, action) => {
            state.seciliHastaListesi = action.payload
        },
        setSeciliOrderIlacListesi: (state, action) => {
            state.seciliOrderIlacListesi = action.payload
        },
        setAktifSeciliHastaListesi: (state, action) => {
            state.aktifSeciliHastaListesi = action.payload
        },
        setAktifSeciliIlacListesi: (state, action) => {
            state.aktifSeciliIlacListesi = action.payload
        },
        setKaldirilanIlacIdListesi: (state, action) => {
            state.kaldirilanIlacIdListesi = action.payload
        },
        setServisList: (state, action) => {
            state.servisList = action.payload
        },
        setOnayliHastaListesi: (state, action) => {
            state.onayliHastaListesi = action.payload
        },
        setOnayliIlacListesi: (state, action) => {
            state.onayliIlacListesi = action.payload
        },
        setOnayliAramaKriterleri: (state, action) => {
            state.onayliAramaKriterleri = action.payload
        },
        setOnayliIlacActiveRow: (state, action) => {
            state.onayliIlacActiveRow = action.payload
        },
        setOnayliHastaActiveRow: (state, action) => {
            state.onayliHastaActiveRow = action.payload
        },
        setIptalOrderAramaKriterleri: (state, action) => {
            state.iptalOrderAramaKriterleri = action.payload
        },
        setIptalOrderListesi: (state, action) => {
            state.iptalOrderListesi = action.payload
        },
        setIptalOrderSeciliList: (state, action) => {
            state.iptalOrderSeciliList = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(OrderTalepApi.endpoints.GetOrderTalepler.matchFulfilled, (state, action) => {
            state.orderList = action.payload;
        })
        // builder.addMatcher(OrderTalepApi.endpoints.GetOrderIlac.matchFulfilled, (state, action) => {
        //     state.orderDetayList = action.payload;
        // })
    }
})

export default OrderTalepSlice;